// extracted by mini-css-extract-plugin
module.exports = {"PricingTable":"PricingTable_PricingTable__E_j8O","u-wrapper":"PricingTable_u-wrapper___6Hwv"};